import { Box } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';

import { WosIsiReportPage } from '@/module/WosIsiReport';

export const Route = createFileRoute('/_auth/author/_author/wos-isi-report')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'wosIsiReport.title' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <WosIsiReportPage />
    </Box>
  );
}
